module.exports = __webpack_public_path__ + "static/media/ResponseStage.f58473e5.svg";